import { formatDateInUTC } from 'bl-utils/src/formatting/formatDate'

export const isExcludedComparisonCard = (
  comparisonCard: {
    excludedDates?: string[] | undefined
  },
  arrivalDate: string
): boolean => {
  if (arrivalDate == null) {
    return false
  }
  if (
    comparisonCard.excludedDates == null ||
    comparisonCard.excludedDates.length === 0
  ) {
    return false
  }

  return comparisonCard.excludedDates.some(
    date => date === formatDateInUTC(arrivalDate, 'yyyy-MM-dd')
  )
}
